import React, { useState } from "react";
import { inject, observer } from "mobx-react";
import styled from "@emotion/styled";
import { css } from "@emotion/react";

import { useScrollControl } from "./hooks/useScrollControl";
import { Button } from "components/ui/Button";
import { Modal } from "components/modal/compound/Modal";
import { delivery_connect_request } from "http/DetailConn";
import { fn_devliery_connect_add_reset } from "../../../../function/FnBodyDelivery";

interface Shop {
  agencyCode: string;
  strNm: string;
  strAddr: string;
  storeTel: string;
}

const DlvConnectShopResult = ({ rootStore }: any) => {
  const { layerStore, deliveryStore, settingStore } = rootStore;
  const { scrollContainerRef, onUpClick, onDownClick } = useScrollControl();

  const [selectedId, setSelectedId] = useState<string>("");
  const handleSelect = (agencyCode: string, shopNmae: string) => {
    setSelectedId(prevId => (prevId === agencyCode ? "" : agencyCode));
    settingStore.setDlvRegistInfo("agencyCode", agencyCode);
    settingStore.setDlvRegistInfo("shopName", shopNmae);
  };

  const handleConnect = () => {
    setSelectedId("");
    delivery_connect_request(rootStore);
  };

  if (!layerStore.getLayerDlvConnectShopView) {
    return null;
  }

  return (
    <Modal.BackGround containerWidth="529px" border={true}>
      <Modal.Header
        title={settingStore.getDlvRegistInfo.deliveryServiceName + " 연동"}
        onClose={() => {
          fn_devliery_connect_add_reset(rootStore);
          settingStore.setDlvConnectResult("");
          deliveryStore.setDlvConnectCode([]);
          layerStore.setLayerDlvConnectShopView(false);
          setSelectedId("");
        }}
      />

      <ContentWrap>
        <ContentTopTitle>연동할 가게를 선택하세요</ContentTopTitle>
        <Spacer height="24px" />
        <>
          <ContentTopTxt>가게 목록</ContentTopTxt>
          <Spacer height="8px" />
          <Modal.ContentByScroll
            scrollContainerRef={scrollContainerRef}
            onUpClick={onUpClick}
            onDownClick={onDownClick}
          >
            {deliveryStore?.getDlvConnectShopList?.map((shop: Shop) => (
              <List
                key={shop.agencyCode}
                isSelected={selectedId === shop.agencyCode}
                onClick={() => handleSelect(shop.agencyCode, shop.strNm)}
              >
                <ListWrap>
                  <Text color="#323639" size="16px" weight="700" flex="1">
                    {shop.strNm}
                  </Text>
                  <Text color="#323639" size="16px" weight="400">
                    {shop.agencyCode}
                  </Text>
                </ListWrap>
                <ListWrap>
                  <Text size="14px" weight="400" flex="1">
                    {shop.strAddr}
                  </Text>
                  <Text size="14px" weight="400">
                    {shop.storeTel}
                  </Text>
                </ListWrap>
              </List>
            ))}
          </Modal.ContentByScroll>
        </>
      </ContentWrap>
      <Spacer height="36px" />
      <Divider />

      <Modal.Bottom>
        <Button
          variant="white"
          size="sm"
          onClick={() => {
            layerStore.setLayerDlvConnectShopView(false);
            setSelectedId("");
          }}
        >
          취소
        </Button>
        <Button variant="black" size="sm" onClick={handleConnect} disabled={selectedId === ""}>
          연동하기
        </Button>
      </Modal.Bottom>
    </Modal.BackGround>
  );
};

interface SpacerProps {
  height?: string;
}

interface ListProps {
  isSelected: boolean;
}

interface TextProps {
  color?: string;
  size?: string;
  weight?: string;
  flex?: string;
}

export default inject("rootStore")(observer(DlvConnectShopResult));

const ContentWrap = styled.div`
  padding: 16px 16px 0 16px;
`;

const ContentTopTitle = styled.div`
  color: #000;
  font-size: 19px;
  font-weight: 700;
  line-height: 28px;
`;

const ContentTopTxt = styled.div`
  color: #555c62;
  font-size: 15px;
  font-weight: 700;
  line-height: 22px;
`;

const Spacer = styled.div<SpacerProps>`
  height: ${({ height }) => height || "24px"};
  flex-shrink: 0;
`;

const Divider = styled.div`
  height: 1px;
  background: #d9d9d9;
  margin: 0 16px;
`;

const List = styled.li<ListProps>`
  display: flex;
  flex-direction: column;
  padding: 11px 10px;
  border-bottom: 1px solid #b2b3b4;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #f0f0f0;
  }

  ${({ isSelected }) =>
    isSelected &&
    css`
      background: #047bbc;

      &:hover {
        background: #047bbc;
      }

      & > div:first-of-type p {
        color: #ffee98;
        font-weight: 700;
      }

      & > div:last-of-type p {
        color: #fff;
      }
    `}
`;

const ListWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const Text = styled.p<TextProps>`
  color: ${({ color }) => color || "#333B42"};
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  font-size: ${({ size }) => size || "14px"};
  font-weight: ${({ weight }) => weight || "400"};
  line-height: 150%;

  ${({ flex }) => flex && `flex: ${flex};`}
`;
